import React, { useMemo } from 'react';

import {
  Screen,
  useScreenState,
  useScreenDispatch,
  useScreenName,
  APPLY_PRESET,
} from '@gogame/screens';

import Presets from './Presets';

export const ScreenPresets = ({
  mapStateToPreset,
  activePresetId: customActivePresetId,
  onApply: customOnApply,
  name: customName,
  isAddPresetWithGroup = false,
  isManageGroups = false,
  getActivePresetData,
}) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const name = useScreenName();
  const presetKey = customName || name;
  const activePresetId =
    customActivePresetId || (screenState && screenState.presetId);

  const presetData = useMemo(
    () => (mapStateToPreset ? mapStateToPreset(screenState) : screenState),
    [screenState]
  );

  const defaultApply = (payload, meta) => {
    dispatch({
      type: APPLY_PRESET,
      payload,
      meta,
    });
  };

  let handleApply = customOnApply || defaultApply;

  return (
    <Screen.Toolbar.Presets>
      <Presets
        onApply={handleApply}
        activePresetId={activePresetId}
        data={presetData}
        screen={presetKey}
        isAddPresetWithGroup={isAddPresetWithGroup}
        isManageGroups={isManageGroups}
        grouped={isManageGroups}
        getActivePresetData={getActivePresetData}
      />
    </Screen.Toolbar.Presets>
  );
};

export default ScreenPresets;
